import type { ReactNode } from 'react';

import ErrorBoundary from './index';
import IntlProviderErrorFallback from './intl-provider-error-fallback';

type AppIntlErrorShellProps = {
  children: ReactNode;
};

/**
 * Outer shell for app roots: catches `HeidiIntlProvider` setup failures with an
 * intl-free fallback. Call sites must mount `HeidiIntlProvider` as a direct
 * child, then the inner `ErrorBoundary` (localized `ErrorComponent` fallback)
 * below that.
 */
export function AppIntlErrorShell({ children }: AppIntlErrorShellProps) {
  return (
    <ErrorBoundary name="app_intl_shell" fallback={IntlProviderErrorFallback}>
      {children}
    </ErrorBoundary>
  );
}
